import React from "react";

const ServiceAgreementForm = () => {
  return (
    <>
      <html xmlns="http://www.w3.org/1999/xhtml">
        <head>
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
          <title></title>
        </head>
        <body>
          <table
            width={1000}
            border={0}
            align="center"
            cellPadding={0}
            cellSpacing={0}
          >
            <tbody>
              <tr>
                <td
                  colSpan={3}
                  style={{
                    fontFamily: "Tahoma, Geneva, sans-serif",
                    fontSize: "1.7em",
                    color: "#F00",
                    fontWeight: "bold",
                    padding: "5px 0 0px 0",
                    letterSpacing: ".03em",
                  }}
                >
                  TCS Service Agreement Form
                </td>
              </tr>
              <tr>
                <td
                  colSpan={3}
                  style={{
                    fontFamily: "Tahoma, Geneva, sans-serif",
                    fontSize: ".88em",
                    fontWeight: "bold",
                    padding: "2px 0 5px 0",
                  }}
                >
                  (Terms &amp; Condition) Formerly AOF (Account Opening Form)
                </td>
              </tr>
              <tr>
                <td
                  colSpan={3}
                  style={{
                    fontFamily: "Arial, Helvetica, sans-serif",
                    fontSize: 13,
                    fontWeight: "bold",
                    fontStyle: "italic",
                    padding: "2px 0 15px 0",
                    textAlign: "justify",
                  }}
                >
                  The Shipper/Client acknowledges and accepts these terms and
                  conditions and relieving TCS (Pvt.) Limited/TCS Logistics
                  (Pvt) Limited (“TCS”) from any liabilities, responsibilities,
                  claims, proceedings, suits, etc. against any damage, loss or
                  expense suffered in connection with the services hereunder and
                  also agreeing that TCS will only be responsible for the
                  carriage of document/parcel which is the only function and
                  responsibility of TCS.
                </td>
              </tr>
              <tr>
                <td width={490} valign="top">
                  <table width={490} border={0} cellSpacing={0} cellPadding={0}>
                    <tbody>
                      <tr>
                        <td
                          width={30}
                          height={25}
                          align="center"
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          1.
                        </td>
                        <td
                          width={460}
                          height={25}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          TCS Consignment Note:
                        </td>
                      </tr>
                      <tr>
                        <td width={30} align="center">
                          &nbsp;
                        </td>
                        <td
                          width={460}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "normal",
                            textAlign: "justify",
                          }}
                        >
                          The Consignment Note of TCS (CN) is non-negotiable and
                          the Shipper/Sender acknowledges that it has been
                          prepared by the Shipper/Sender or by TCS staff on
                          behalf of the Shipper. The Shipper/Client confirms
                          that all the information provided to TCS while booking
                          the shipment are complete and correct including
                          Shippers and Consignee details, goods value
                          declaration etc. In case of any incorrect information
                          or declaration in the CN, the Shipper/Client
                          acknowledges that TCS will be absolved from any
                          liability or responsibility pertaining to loss, damage
                          or expense suffered by the Shipper/Client.
                        </td>
                      </tr>
                      <tr>
                        <td
                          width={30}
                          height={25}
                          align="center"
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          2.
                        </td>
                        <td
                          width={460}
                          height={25}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          No Variation:
                        </td>
                      </tr>
                      <tr>
                        <td width={30} align="center">
                          &nbsp;
                        </td>
                        <td
                          width={460}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "normal",
                            textAlign: "justify",
                          }}
                        >
                          These terms and conditions are applicable on all
                          courier and logistics services provided by TCS to the
                          Shipper/Client hereunder.&nbsp; No employee,
                          franchisee, agent of TCS or anyone else has any
                          authority to change any of these terms and conditions,
                          or make any promise on behalf of TCS which is in
                          addition to or conflict with these Terms and
                          Conditions.
                        </td>
                      </tr>
                      <tr>
                        <td
                          width={30}
                          height={25}
                          align="center"
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          3.
                        </td>
                        <td
                          width={460}
                          height={25}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          Right of Inspection of Shipment:{" "}
                        </td>
                      </tr>
                      <tr>
                        <td width={30} align="center">
                          &nbsp;
                        </td>
                        <td
                          width={460}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "normal",
                            textAlign: "justify",
                          }}
                        >
                          TCS has the right, but not the obligation, to inspect
                          any shipment including without limitation opening the
                          shipment if required by law and/or regulations. In
                          this regard, the Shipper/Client agrees that TCS may
                          open and inspect a shipment for any reason at any
                          time.
                        </td>
                      </tr>
                      <tr>
                        <td
                          width={30}
                          height={25}
                          align="center"
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          4.
                        </td>
                        <td
                          width={460}
                          height={25}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          Lien of Goods Shipped:{" "}
                        </td>
                      </tr>
                      <tr>
                        <td width={30} align="center">
                          &nbsp;
                        </td>
                        <td
                          width={460}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "normal",
                            textAlign: "justify",
                          }}
                        >
                          TCS shall have a lien on any goods shipped for all
                          freight Charges, Octroi, duties, advances or any other
                          charges of any kind payable by the
                          Shipper/Client&nbsp; hereunder and may refuse to
                          surrender possession of the goods until such charges
                          are paid by the Shipper/Client.
                        </td>
                      </tr>
                      <tr>
                        <td
                          width={30}
                          height={25}
                          align="center"
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          5.
                        </td>
                        <td
                          width={460}
                          height={25}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          Limitation of Liability:
                        </td>
                      </tr>
                      <tr>
                        <td width={30} align="center">
                          &nbsp;
                        </td>
                        <td
                          width={460}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "normal",
                            textAlign: "justify",
                          }}
                        >
                          The Shipper agrees that in case of any damage or loss
                          to the shipment or any part thereof, the maximum
                          liability of TCS to pay any compensation for damage or
                          loss or failure to deliver the consignment shall be
                          limited to the lowest of the following:
                          <br />
                          <br />{" "}
                          <li>
                            PKR. 100/- (Rupee One Hundred only) in case of
                            document shipments with origin and destination
                            within Pakistan);&nbsp;
                          </li>
                          <br />
                          <li>
                            PKR. 100/- (Rupee One Hundred only) per kilogram in
                            case of parcel shipments with origin and destination
                            within Pakistan);
                          </li>
                          <br />
                          <li>
                            USD 10/- (US Dollar Ten only) in case of document
                            shipments with destination outside Pakistan);&nbsp;
                          </li>
                          <br />
                          <li>
                            USD 20/- (US Dollar Twenty only) per kilogram in
                            case of parcel shipments with destination outside
                            Pakistan);
                          </li>
                          <br />
                          <li>
                            The actual value of the document or parcel (lost or
                            damaged), as defined in clause 6 below, without
                            regard to its commercial utility or special value to
                            the Shipper/Client, provided the said loss or damage
                            is suffered solely due to negligence and willful
                            act&nbsp; of TCS&nbsp; (proof of value may also be
                            required).
                          </li>
                        </td>
                      </tr>
                      <tr>
                        <td
                          width={30}
                          height={25}
                          align="center"
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          6.
                        </td>
                        <td
                          width={460}
                          height={25}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          Actual Value:
                        </td>
                      </tr>
                      <tr>
                        <td width={30} align="center">
                          &nbsp;
                        </td>
                        <td
                          width={460}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "normal",
                            textAlign: "justify",
                          }}
                        >
                          <li>
                            The actual value of a document (which terms shall
                            include any item of no commercial value which is
                            transported hereunder) shall be ascertained by
                            reference to the lowest of either its cost of its
                            preparation or replacement or reconstruction value
                            at the time and place of shipment, whichever is
                            less;
                          </li>
                          <br />
                          <li>
                            The actual value of a parcel/goods (which terms
                            shall include any item of commercial value which is
                            transported hereunder) shall be ascertained by
                            reference to the lowest of either its cost of
                            preparation or replacement or repairing or fair
                            market value at the time and place of shipment,
                            whichever is less. In no event shall such value
                            exceed the original cost of the parcel actually paid
                            by the Shipper/Client.
                          </li>
                        </td>
                      </tr>
                      <tr>
                        <td
                          width={30}
                          height={25}
                          align="center"
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          7.
                        </td>
                        <td
                          width={460}
                          height={25}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          Consequential Damages Exclude:{" "}
                        </td>
                      </tr>
                      <tr>
                        <td width={30} align="center">
                          &nbsp;
                        </td>
                        <td
                          width={460}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "normal",
                            textAlign: "justify",
                          }}
                        >
                          TCS shall not be liable in any consequential or
                          special damages or other indirect loss. However
                          arising, whether or not TCS had knowledge that such
                          damages might be incurred, including but limited to
                          loss of income, profit, interest, use of{" "}
                        </td>
                      </tr>
                      <tr>
                        <td
                          height={25}
                          align="center"
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          8.
                        </td>
                        <td
                          height={25}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          Liabilities Not Assumed:{" "}
                        </td>
                      </tr>
                      <tr>
                        <td width={30} align="center">
                          &nbsp;
                        </td>
                        <td
                          width={460}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "normal",
                            textAlign: "justify",
                          }}
                        >
                          The Shipper/Sender acknowledges that the
                          consignment/shipment shall be transported by road
                          and/or air and shall therefore be exposed to all risks
                          usually to be associated with such mode of
                          transportation. Subject to the aforesaid, TCS endeavor
                          to exercise its best efforts to provide expeditious
                          deliver in accord with regular delivery schedule;
                          however,&nbsp; TCS will not, under any circumstances
                          be liable for delay in pick up, transport or delivery
                          of any shipment regardless of the cause of such delay.
                          Further TCS shall not liable if a shipment is lost,
                          damaged, mis-delivered or not delivered because of
                          circumstances beyond its control. These include
                          <br />
                          <br />
                          <li>
                            “Act of God” for example earthquake, cyclone, storm,
                            flood or “force majeure” for example war, plane
                            crash or embargo or caused by mishap with TCS
                          </li>
                          <br />
                          <li>
                            The act, default or omission of the Shipper/Client,
                            the or any other party who claims an interest in the
                            shipment (include violation of any terms and
                            condition hereof) or any person other than TCS or of
                            any Government officials or of the Postal service
                            forwarded or other entity or person to whom a
                            shipment is tendered by TCS or transportation to any
                            location not regularly served by TCS regardless of
                            whether the Shipper/Client reported or had knowledge
                            of such third party delivery arrangements.
                          </li>
                          <br />
                          <li>
                            {" "}
                            The nature of the shipment for any defect,
                            characteristic, inherent vice thereof, even if know
                            to TCS when the Shipper/Client accepted it.
                          </li>
                          <br />
                          <li>
                            Electrical or magnetic energy erasure or other such
                            damage to electronic or photographic images or
                            recording in any form.
                          </li>
                        </td>
                      </tr>
                      <tr>
                        <td width={30} align="center">
                          &nbsp;
                        </td>
                        <td
                          width={460}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "normal",
                            textAlign: "justify",
                          }}
                        >
                          &nbsp;
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td width={20} valign="top">
                  &nbsp;
                </td>
                <td width={490} valign="top">
                  <table width={490} border={0} cellSpacing={0} cellPadding={0}>
                    <tbody>
                      <tr>
                        <td
                          height={25}
                          align="center"
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          9.
                        </td>
                        <td
                          height={25}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          Claims:
                        </td>
                      </tr>
                      <tr>
                        <td
                          align="center"
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          &nbsp;
                        </td>
                        <td
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "normal",
                            textAlign: "justify",
                          }}
                        >
                          <li>
                            Any claim must be brought by the
                            Shipper/Client&nbsp; and delivered in writing to the
                            office of TCS nearest the location at which the
                            shipment was accepted within 30 days of the date of
                            such acceptance, no claim may be made against TCS
                            outside if this time limit.
                          </li>
                          <br />
                          <li>
                            No claim for loss or damage will be entertained
                            until all transportation charges have been paid. The
                            amount of any claim may not be deducted from any
                            transportation charges owed to TCS
                          </li>
                          <br />
                          <li>
                            TCS does not maintain records relevant to a shipment
                            of more than 45 days. It will thereof be unable to
                            refer to or produce any such record where it is
                            notified for the same after expiry of the said
                            period of 45 days from the date of shipment.
                          </li>
                        </td>
                      </tr>
                      <tr>
                        <td
                          width={30}
                          height={25}
                          align="center"
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          10.
                        </td>
                        <td
                          width={460}
                          height={25}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          Applicability:
                        </td>
                      </tr>
                      <tr>
                        <td width={30} align="center">
                          &nbsp;
                        </td>
                        <td
                          width={460}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "normal",
                            textAlign: "justify",
                          }}
                        >
                          These term and conditions shall apply to and insure to
                          the benefit, of TCS Private Limited/TCS Logistics
                          (Pvt) Limited, and its authorized and affiliated
                          companies, and their officers, directors and
                          employees.
                        </td>
                      </tr>
                      <tr>
                        <td
                          width={30}
                          height={25}
                          align="center"
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          11.
                        </td>
                        <td
                          width={460}
                          height={25}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          Material Not Acceptable For Transportation:
                        </td>
                      </tr>
                      <tr>
                        <td width={30} align="center">
                          &nbsp;
                        </td>
                        <td
                          width={460}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "normal",
                            textAlign: "justify",
                          }}
                        >
                          TCS does not accept as a shipment Currency, Jewelry,
                          Bullion, Antiques, Liquor, Stamps, Precious Metals,
                          Precious Stones, Contraband, Work of Art, Fire arms,
                          Plants, Drugs, Explosives, Animals, Perishable,
                          Negotiable Instruments in bearer Form, Lewd, Obscene
                          or Pornographic Materials, Industrial Carbons and
                          Diamonds, items/articles restricted by IATA
                          (International Air Transport Association) or ICAO
                          (International Civil Aviation Organization), hazardous
                          or combustible material, property of carriage of which
                          is prohibited by any law, regulation or statute of any
                          Provincial or Federal Government of Pakistan.
                        </td>
                      </tr>
                      <tr>
                        <td
                          width={30}
                          height={25}
                          align="center"
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          12.
                        </td>
                        <td
                          width={460}
                          height={25}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          Insurance:{" "}
                        </td>
                      </tr>
                      <tr>
                        <td width={30} align="center">
                          &nbsp;
                        </td>
                        <td
                          width={460}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "normal",
                            textAlign: "justify",
                          }}
                        >
                          <li>
                            At request of the Shipper/Client and upon payment
                            thereof, TCS will arrange insurance on behalf of the
                            Shipper/Client. The insurance coverage shall be
                            governed by all the terms and conditions contained
                            in the policy of the insurance issued by the
                            insurance company.{" "}
                          </li>
                          <br />
                          <li>
                            The Shipper/Client acknowledges that the
                            consequential damages and loss or damage resulting
                            from delay of transportation are not covered by any
                            such policy of insurance.
                          </li>
                        </td>
                      </tr>
                      <tr>
                        <td
                          width={30}
                          height={25}
                          align="center"
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          13.
                        </td>
                        <td
                          width={460}
                          height={25}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          Lawfulness of Shipment/Goods:
                        </td>
                      </tr>
                      <tr>
                        <td width={30} align="center">
                          &nbsp;
                        </td>
                        <td
                          width={460}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "normal",
                            textAlign: "justify",
                          }}
                        >
                          <li>
                            It is hereby undertaken and confirmed by the
                            Shipper/Client that the shipment/goods being
                            stored/transported hereunder through TCS have been
                            acquired by the Shipper/Client lawfully and no law
                            whatsoever has been breached in acquisition thereof.
                            It is further undertaken and confirmed that all the
                            relevant and necessary documents pertaining to the
                            shipments/goods are in possession of Shipper/Client
                            who will be liable and responsible to provide all
                            and any document as and when required by TCS for
                            their onward submission to any Government
                            Agency/Department/Authority etc.
                          </li>
                          <br />
                          <li>
                            It is further undertaken and confirmed by the
                            Shipper/Client that the Shipper/Client shall make
                            himself and/or any documents whatsoever available at
                            all material time and in the event that TCS and/or
                            any Government Agency/Department/Authority etc has
                            any query in relation to all and any aspect of
                            shipments/goods.
                          </li>
                          <br />
                          <li>
                            It is further undertaken and declared that TCS being
                            only responsible for warehousing/transportation of
                            shipments/goods of Shipper, any liability, loss,
                            claim, demand, action, proceeding etc as may
                            occasion to TCS shall be made good and be fully
                            indemnified by the Shipper/Client in relation
                            thereto.
                          </li>
                        </td>
                      </tr>
                      <tr>
                        <td
                          width={30}
                          height={25}
                          align="center"
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          14.
                        </td>
                        <td
                          width={460}
                          height={25}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          If the Shipper Has Asked Us To Bill The Receiver/Third
                          Party:
                        </td>
                      </tr>
                      <tr>
                        <td width={30} align="center">
                          &nbsp;
                        </td>
                        <td
                          width={460}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "normal",
                            textAlign: "justify",
                          }}
                        >
                          The shipper agrees to pay all shipment charges and
                          destination duties and taxes, for the shipment if the
                          receiver or third party does not pay.
                        </td>
                      </tr>
                      <tr>
                        <td
                          width={30}
                          height={25}
                          align="center"
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          15.
                        </td>
                        <td
                          width={460}
                          height={25}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          Warsaw Convention:
                        </td>
                      </tr>
                      <tr>
                        <td width={30} align="center">
                          &nbsp;
                        </td>
                        <td
                          width={460}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "normal",
                            textAlign: "justify",
                          }}
                        >
                          <li>
                            <p>
                              If the transportation of a shipment involves an
                              ultimate destination or stop in a country other
                              than the country of departure, the Warsaw
                              Convention may apply. <br />
                              The Warsaw Convention governs, and in most cases
                              furthers limits, our liability for loss or damage
                              to such a shipment.
                            </p>
                          </li>
                        </td>
                      </tr>
                      <tr>
                        <td
                          width={30}
                          height={25}
                          align="center"
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          16.
                        </td>
                        <td
                          width={460}
                          height={25}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          <p>Oversized/Odd Sized Shipment:</p>
                        </td>
                      </tr>
                      <tr>
                        <td width={30} align="center">
                          &nbsp;
                        </td>
                        <td
                          width={460}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "normal",
                            textAlign: "justify",
                          }}
                        >
                          <p>
                            Additional charges for lifter/cranes, special
                            handling would also apply along with agreed rates
                            shipment weight would be charged gross or volumetric
                            whichever will be higher.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          height={25}
                          align="center"
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          17.
                        </td>
                        <td
                          height={25}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                        >
                          Variable Fuel Adjustment Would be Applicable As Per
                          Practice/Arrangements
                        </td>
                      </tr>
                      <tr>
                        <td width={30} align="center">
                          &nbsp;
                        </td>
                        <td
                          width={460}
                          style={{
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontSize: 12,
                            fontWeight: "normal",
                            textAlign: "justify",
                          }}
                        >
                          <b>Important Note:</b>
                          <br />
                          By the terms and conditions set out above, TCS Private
                          Limited/ TCS Logistics Private Limited and its
                          servants and agents are firstly not liable at all for
                          certain losses and damages and secondly wherever they
                          are to be liable, the amount of liability is strictly
                          limited to the amount stated above. Customers are
                          therefore advised to purchase insurance cover to
                          ensure that their risk and interest are
                          covered.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                          <p />
                          <p>
                            Payment to be made within 7 days of receipt of
                            invoice. TCS reserves the right to withdraw any
                            service facility in case of delay of more than 30
                            days for settlement of account. In case the account
                            is not settled within 30 days of receipt of invoice,
                            TCS reserve the right to levy financial charges on
                            outstanding invoice amount at the rate of 0.1% per
                            day till complete clearance of total dues. Further,
                            TCS shall also be entitled to suspend its services
                            till all outstanding is cleared by the
                            Shipper/Client.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td width={30} align="center">
                          &nbsp;
                        </td>
                        <td width={460}>&nbsp;</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <table
            width={1000}
            border={0}
            align="center"
            cellPadding={0}
            cellSpacing={0}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    fontFamily: "Tahoma, Geneva, sans-serif",
                    fontSize: "1.3em",
                    color: "#000000",
                    backgroundColor: "#999999",
                    fontWeight: "bold",
                    padding: "5px 0 5px 0",
                    letterSpacing: ".03em",
                    textAlign: "center",
                  }}
                >
                  DECLARATION
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    fontFamily: "Tahoma, Geneva, sans-serif",
                    fontSize: ".9em",
                    color: "#000000",
                    fontWeight: "bold",
                    padding: "5px 0 3px 0",
                    letterSpacing: ".0em",
                  }}
                >
                  Please read carefully.
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    fontFamily: "Arial, Helvetica, sans-serif",
                    fontSize: 12,
                    fontWeight: "normal",
                    textAlign: "justify",
                    paddingBottom: 20,
                  }}
                >
                  I/We confirm that all particulars/information/documents
                  provided above are true, complete and accurate and I/we have
                  not withheld any information. I/We confirm that &nbsp;/We have
                  no insolvency proceedings initiated against me/us nor have
                  I/We ever been adjudicated insolvent or convicted for
                  financial impropriety/money laundering. I/We authorize TCS or
                  its agent (s) to seek references &amp; inquiries relative to
                  information in this application, which TCS consider necessary.
                  I/We agree and acknowledge that TCS reserves the right to
                  reject this application without assigning/giving any reason.
                  I/We authorize TCS to make any enquiries TCS consider
                  necessary to verify the information for credit assessment
                  purpose. I/We also understand that any wrong information
                  provided by me / us or withheld would render my/our
                  application liable to rejection.
                  <br />
                  <br />
                  I/We acknowledge and agree that all information including
                  personal data provided by me/us may be used and disclosed by
                  TCS for such purpose and to such persons in accordance with
                  TCS’s policies on use and disclosure of personal data. I/We
                  acknowledge and warrant that all of its performances &amp;
                  data/particulars/documents provided to TCS in pursuance of
                  their business are lawful and do not contain any contraband or
                  any prohibited goods or material in compliance with the Laws
                  of Islamic Republic of Pakistan.I/We agree that in case of
                  violation of any terms/conditions under this Declaration TCS
                  holds the right to approach any court of jurisdiction to
                  initiate any proceedings provided under law and equity.
                </td>
              </tr>
            </tbody>
          </table>
        </body>
      </html>
    </>
  );
};

export default ServiceAgreementForm;
